

<!--start section header-->

<header class="head d-flex justify-content-center align-items-center">

    <div class="head-caption text-center">
     <h1>RESERVATION</h1>
     <p>Tomato is a delicious restaurant website template</p>
    </div>
 
 </header>

<!--end section header-->

<!--start section reserv-->
 <section class="container py-5 reserv">
    <div class=" text-center"> 
      <h1>RESERVATIONS</h1>
      <p class="text-muted">Book a table online. Leads will reach in your email.</p>
      <div class="mini m-auto mb-5"></div>
   </div> 
   <div class="brdr">
     <div class="row mt-5 d-flex justify-content-center flex-wrap">
  
      <div class="col-md-4 mb-3">
        <div class="form-group">
          <label>Data</label>
          <input  name="udata" class="form-control input-cont border-0" placeholder="Pick a data" >
         
        </div>
  
      </div>
      <div class="col-md-4 mb-3">
        <div class="form-group">
          <label>Your Name</label>
          <input type="text" name="uname" class="form-control input-cont border-0" placeholder="Full Name">
          
        </div>
  
      </div>
      <div class="col-md-4 mb-3">
        <div class="form-group">
          <label>Time</label>
          <input  name="utime" class="form-control input-cont border-0" placeholder="Pick a Time">
        </div>
  
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Email Address</label>
          <input type="email" name="uemail" class="form-control input-cont border-0" placeholder="Your Email ID">
        </div>
  
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Guests</label>
          <input type="text" name="uguests" class="form-control input-cont border-0" placeholder="How Many You">
        </div>
  
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>phone Number</label>
          <input type="number" name="unumber" class="form-control input-cont border-0" placeholder="Enter your phone Number">
        </div>
  
      </div>
      
      
    
     </div>
  
        <div class="m-auto pt-4 pb-4 text-center">
           <button type="submit" class="btn btn-reserv p-3">MAKE RESERVATIONS</button>
        </div>
        <div class="reserv-footer m-auto text-center p-4">
           <p class="text-muted">You can also call: <span >+1 224 6787 004</span> to make a reservation.</p>
        </div>
    </div>    
  
  
  </section>
<!--end section reserv-->
  
<!--start section insta-->
  <section class="bg">

    <div class="container py-4">

     <div class="row insta-caption">
        <div class="col-md-3 sub-caption">
            <p>SUBSCRIBE</p>
        </div>
        <div class="col-md-8">
         <p class="text-muted p">Get updates about new dishes and upcoming events</p>
     </div>
       
       </div>
       <div class="registers d-flex justify-content-end pb-4">
         <input class="inpt-caption mr-4" type="email" placeholder=" Your Email Address ">
         <button type="submit" class="register"><i class="fas fa-chevron-right fa-1x"></i></button>
       </div>

    </div>
</section>
<!--end section insta-->  

